import { useCreateProjectPartner } from 'lib/hooks/project/useCreateProjectPartner';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CreateProjectTab from './CreateProjectTab';
import ProjectSyncPartner from './ProjectSyncPartner';

interface CreateProjectPartnerProps {}

const CreateProjectPartner = ({}: CreateProjectPartnerProps) => {
  // SECTION: declare hooks
  const { t } = useTranslation();
  const { selectedSyncPartner, setSelectedSyncPartner, partnerName } = useCreateProjectPartner();

  return (
    <StyledCreateProjectPartner>
      <div className="createProjectPartner__tab_container">
        <CreateProjectTab tabTitle={t('GLOBAL_PARTNER')} />
      </div>
      <div className="createProjectPartner__content">
        <ProjectSyncPartner
          size="md"
          value={selectedSyncPartner}
          setValue={setSelectedSyncPartner}
          returnPath="edit"
        />
        {/* {!!partnerName ? (
          <div className="createProjectPartner__partner_box">
            <CustomText fontSize={20} fontWeight={400} fontColor="#888">
              {partnerName}
            </CustomText>
          </div>
        ) : (
          <ProjectSyncPartner
            size="md"
            value={selectedSyncPartner}
            setValue={setSelectedSyncPartner}
          />
        )} */}
      </div>
    </StyledCreateProjectPartner>
  );
};

const StyledCreateProjectPartner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .createProjectPartner__tab_container {
  }
  .createProjectPartner__content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .createProjectPartner__partner_box {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 10px 12px;
      margin: 20px;
      border: 1px solid #e1e1e7;
      border-radius: 3px;
    }
  }
`;

export default CreateProjectPartner;
